const SET_FISCALYEAR = "infra/SET_FISCALYEAR";

export default {
  SET_FISCALYEAR
};



// WEBPACK FOOTER //
// ./src/infraMonitor/fiscalyear/types.js